import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { RouteTicketProviderTicket } from 'routes'

import Table from 'components/Shared/TableNew/Index'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import TableCellWithActions from 'components/Shared/TableNew/TableCellWithActions'
import TableRowNoData from 'components/Shared/TableNew/TableRowNoData'
import ShowOnRowHover from 'components/Shared/TableNew/ShowOnRowHover'
import CopyIcon from 'components/Shared/CopyIcon/Index'

import CommentCellContent from 'components/App/TicketPage/TicketComments/CommentCellContent'

const ActionsCellContent = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`

const ActionIcons = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 8px;
`

const CommentsTable = ({
  ticket, comments, anchorElementId, searchValue, hasRichText,
}) => {
  const { t } = useTranslation()

  const buildCommentLink = (commentId) => {
    const ticketUrl = RouteTicketProviderTicket({
      ticketProviderId: ticket.ticketProviderId,
      ticketId: ticket.externalId,
    })

    return `${window.location.origin}${ticketUrl}#comments-${commentId}`
  }

  return (
    <Table width='100%' maxWidth='1112px'>
      <TableBody hoverable>
        {comments.map(comment => {
          const anchorCommentId = `comments-${comment.id}`
          const isActiveRow = Boolean(anchorElementId === anchorCommentId)

          return (
            <TableRow
              key={comment.id}
              id={anchorCommentId}
              active={isActiveRow}
            >
              <TableCell>
                <CommentCellContent
                  comment={comment}
                  searchValue={searchValue}
                  hasRichText={hasRichText}
                />
              </TableCell>
              <TableCellWithActions>
                <ActionsCellContent>
                  <ShowOnRowHover>
                    <ActionIcons>
                      <CopyIcon
                        copyText={buildCommentLink(comment.id)}
                        icon='icon-status-bonded'
                        tooltipPlace='top'
                        tooltipText={t('common.tooltipCopyLink')}
                      />
                      <CopyIcon copyText={comment.body} tooltipPlace='top' />
                    </ActionIcons>
                  </ShowOnRowHover>
                </ActionsCellContent>
              </TableCellWithActions>
            </TableRow>
          )
        })}
        {!comments.length && (
          <TableRowNoData withTopBorder />
        )}
      </TableBody>
    </Table>
  )
}

CommentsTable.propTypes = {
  ticket: PropTypes.object.isRequired,
  comments: PropTypes.array.isRequired,
  anchorElementId: PropTypes.string,
  searchValue: PropTypes.string,
  hasRichText: PropTypes.bool,
}

export default CommentsTable
